export default __webpack_public_path__ + "static/media/ico-locate.0dfd32ac.png";